import React from 'react'
import PropTypes from 'prop-types'
import { TextField, Grid } from '@material-ui/core'
import { Controller, useForm } from 'react-hook-form'

import useSnackbar from 'hooks/useSnackbar'

import schema from './schema'

const ConsentEmailFieldForm = ({
  selectedField,
  selectedItems,
  setSelectedItems,
  setValue,
  onCloseDialog,
}) => {
  const snackbar = useSnackbar()

  const { control, errors, handleSubmit } = useForm({
    validationSchema: schema,
    defaultValues: {
      label: selectedField?.label || '',
      placeholder: selectedField?.placeholder || '',
      helpText: selectedField?.description || '',
    },
  })

  const onSubmit = async (fieldData) => {
    try {
      const newField = {
        ...selectedField,
        label: fieldData.label,
        placeholder: fieldData.placeholder,
        description: fieldData.helpText,
      }

      const newFieldsSelected = selectedItems.map((item) =>
        item.name === selectedField.name ? newField : item,
      )
      setSelectedItems(newFieldsSelected)
      setValue(selectedField.name, {
        subtitle: fieldData.helpText,
        required: !!newField.required,
        order: newField.order,
        label: fieldData.label,
        placeholder: fieldData.placeholder,
      })
    } catch (error) {
      snackbar.open({
        message: 'Ocorreu um erro! Tente novamente.',
        variant: 'error',
      })
    } finally {
      onCloseDialog()
    }
  }

  return (
    <form id="consent-form" onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Controller
            as={
              <TextField
                label="Rótulo do campo"
                fullWidth
                error={!!errors.label}
                helperText={errors?.label?.message}
              />
            }
            control={control}
            name="label"
            mode="onBlur"
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            as={
              <TextField
                label="Texto de exemplo (placeholder)"
                fullWidth
                error={!!errors.placeholder}
                helperText={errors?.placeholder?.message}
              />
            }
            control={control}
            name="placeholder"
            mode="onBlur"
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            as={
              <TextField
                label="Texto de ajuda"
                fullWidth
                error={!!errors.helpText}
                helperText={errors?.helpText?.message}
              />
            }
            control={control}
            name="helpText"
            mode="onBlur"
          />
        </Grid>
      </Grid>
    </form>
  )
}

ConsentEmailFieldForm.propTypes = {
  selectedField: PropTypes.object.isRequired,
  selectedItems: PropTypes.array,
  setSelectedItems: PropTypes.func,
  setValue: PropTypes.func,
  onCloseDialog: PropTypes.func,
}

export default ConsentEmailFieldForm
